/* Laulet: recomendaciones por talla (otras marcas, nunca María Conchita Arcalá). */
(function () {
  'use strict';

  var CFG = window.LAULET_RECS || {};
  var EXCLUDE_VENDOR = CFG.excludeVendor || 'María Conchita Arcalá';
  var MONEY_FORMAT = CFG.moneyFormat || 'RD${{amount}}';
  var FEED_URL = (CFG.feedUrl || '/collections/all') + '?view=laulet-recs';
  var CACHE_KEY = 'lau_recs_feed_v1';
  var CACHE_MS = 10 * 60 * 1000;
  var SIZE_KEY = 'lau_size';
  var US_SIZES = ['5', '6', '7', '8', '9', '10', '11'];
  // Equivalencias según la guía de tallas de la tienda (BR -> US).
  var US_TO_BR = { '4': ['33'], '5': ['34'], '6': ['35', '36'], '7': ['37', '36'], '8': ['38'], '9': ['39'], '10': ['40'], '11': ['41'] };
  var GROUPS = {
    'Sandalia de tacón': 'tacon', 'Zapato de tacón': 'tacon', 'Sandalia de plataforma': 'tacon', 'Cuña': 'tacon',
    'Slingback': 'cerrado', 'Ballerina': 'cerrado', 'Mocasín': 'cerrado', 'Mary Jane': 'cerrado', 'Botín': 'cerrado',
    'Mule': 'mule',
    'Sandalia plana': 'plano', 'Chancleta': 'plano', 'Alpargata': 'plano', 'Tenis': 'plano'
  };

  /* ---------- utilidades ---------- */
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }
  function sstore(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pretty(s) {
    return String(s || '').replace(/[._]+/g, ' ').toLowerCase().replace(/\s+/g, ' ').trim()
      .replace(/(^|\s)\S/g, function (m) { return m.toUpperCase(); });
  }
  function money(cents) {
    var n = Number(cents) / 100;
    function fmt(d, ts, ds) {
      var parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    }
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      return fmt(2, ',', '.');
    });
  }
  function isBR(val) { var s = String(val); return /br/i.test(s) || parseFloat(s) >= 30; }
  function brNum(val) { return String(parseInt(val, 10)); }
  // Convierte cualquier valor de talla a talla US "clave".
  function toUS(val) {
    if (val == null) return null;
    if (isBR(val)) {
      var b = brNum(val);
      for (var us in US_TO_BR) { if (US_TO_BR[us][0] === b) return us; }
      for (var us2 in US_TO_BR) { if (US_TO_BR[us2].indexOf(b) > -1) return us2; }
      return null;
    }
    var n = parseFloat(val);
    return isNaN(n) ? null : String(n);
  }
  // 0 = coincidencia exacta, 1 = equivalencia aproximada, -1 = no sirve.
  function sizeRank(val, us) {
    if (!us) return -1;
    if (isBR(val)) {
      var list = US_TO_BR[us] || [];
      var i = list.indexOf(brNum(val));
      return i === -1 ? -1 : i;
    }
    return String(parseFloat(val)) === us ? 0 : -1;
  }
  function sizeLabel(val, us) {
    if (isBR(val)) return 'Talla ' + brNum(val) + ' BR <span class="lau-recs__eq">(≈ US ' + esc(us) + ')</span>';
    return 'Talla ' + esc(String(parseFloat(val)));
  }

  /* ---------- datos ---------- */
  var feedPromise = null;
  function getFeed() {
    if (feedPromise) return feedPromise;
    try {
      var c = JSON.parse(sstore(CACHE_KEY) || 'null');
      if (c && Date.now() - c.ts < CACHE_MS && c.products) { feedPromise = Promise.resolve(c.products); return feedPromise; }
    } catch (e) {}
    function page(n) {
      return fetch(FEED_URL + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    feedPromise = page(1).then(function (first) {
      var pages = Math.min(first.pages || 1, 4), reqs = [];
      for (var i = 2; i <= pages; i++) reqs.push(page(i));
      return Promise.all(reqs).then(function (rest) {
        var all = first.products || [];
        rest.forEach(function (r) { all = all.concat(r.products || []); });
        all = all.filter(function (p) { return p.v !== EXCLUDE_VENDOR && p.vs && p.vs.length; });
        sstore(CACHE_KEY, JSON.stringify({ ts: Date.now(), products: all }));
        return all;
      });
    }).catch(function (e) { feedPromise = null; throw e; });
    return feedPromise;
  }

  // Devuelve [{p, opts:[{id, color, sizeVal, price, img}], score}]
  function pick(products, opts) {
    var us = opts.size, refTypes = opts.types || [], exclude = opts.excludeIds || [];
    var refGroups = refTypes.map(function (t) { return GROUPS[t]; });
    var out = [];
    products.forEach(function (p) {
      if (exclude.indexOf(p.id) > -1) return;
      var best = 9, matches = [];
      p.vs.forEach(function (v) {
        var sv = v[1][p.si];
        var r = sizeRank(sv, us);
        if (r < 0) return;
        if (r < best) { best = r; matches = []; }
        if (r === best) matches.push({ id: v[0], color: p.ci > -1 ? v[1][p.ci] : '', sizeVal: sv, price: v[2], img: v[3] });
      });
      if (!matches.length) return;
      var score = 0;
      if (refTypes.indexOf(p.ty) > -1) score += 3;
      else if (GROUPS[p.ty] && refGroups.indexOf(GROUPS[p.ty]) > -1) score += 2;
      score += Math.min(matches.length, 3) * 0.2;
      score += Math.random() * 1.6; // variedad entre visitas
      if (best > 0) score -= 0.5;
      out.push({ p: p, opts: matches, score: score });
    });
    out.sort(function (a, b) { return b.score - a.score; });
    return out.slice(0, opts.limit || 8);
  }

  /* ---------- carrito ---------- */
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }
  function cartTarget() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }

  function addToCart(variantId, btn) {
    var target = onCartPage() ? null : cartTarget();
    var body = { id: Number(variantId), quantity: 1 };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Agregando…'; }
    return fetch(base + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message || 'No se pudo agregar');
        if (onCartPage()) { window.location.reload(); return; }
        if (target && typeof target.renderContents === 'function') {
          if (target.classList && target.classList.contains('is-empty')) target.classList.remove('is-empty');
          target.renderContents(res);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'laulet-recs', productVariantId: variantId, cartData: res });
        }
        if (btn) { btn.textContent = 'Agregado ✓'; btn.classList.remove('is-loading'); setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 1800); }
        setTimeout(refreshNotification, 50);
      })
      .catch(function (e) {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.textContent = 'Agotado en esta talla';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 2200);
        }
        try { sessionStorage.removeItem(CACHE_KEY); } catch (er) {}
        feedPromise = null;
        console.warn('[laulet-recs]', e);
      });
  }

  /* ---------- render ---------- */
  function cardHTML(item, us, compact) {
    var p = item.p, o = item.opts[0];
    var img = o.img || p.img;
    var sel = '';
    if (item.opts.length > 1) {
      sel = '<label class="visually-hidden" for="lau-c-' + p.id + (compact ? '-m' : '') + '">Color</label>' +
        '<select class="lau-recs__color" id="lau-c-' + p.id + (compact ? '-m' : '') + '" data-lau-color>' +
        item.opts.map(function (x) {
          return '<option value="' + x.id + '" data-img="' + esc(x.img || p.img || '') + '" data-price="' + x.price + '">' + esc(pretty(x.color) || 'Único') + '</option>';
        }).join('') + '</select>';
    } else if (o.color) {
      sel = '<p class="lau-recs__single">' + esc(pretty(o.color)) + '</p>';
    }
    return '<li class="lau-recs__item" data-variant="' + o.id + '">' +
      '<a class="lau-recs__media" href="' + esc(p.u) + '?variant=' + o.id + '">' +
      (img ? '<img src="' + esc(img) + '" alt="' + esc(p.t) + '" loading="lazy" width="400" height="400">' : '') +
      '</a>' +
      '<div class="lau-recs__info">' +
      '<p class="lau-recs__vendor">' + esc(p.v) + '</p>' +
      '<a class="lau-recs__title" href="' + esc(p.u) + '?variant=' + o.id + '">' + esc(p.t) + '</a>' +
      '<p class="lau-recs__price" data-lau-price>' + money(o.price) + '</p>' +
      '<p class="lau-recs__size">' + sizeLabel(o.sizeVal, us) + '</p>' +
      sel +
      '<button type="button" class="lau-recs__add button button--secondary" data-lau-add>+ Agregar</button>' +
      '</div></li>';
  }

  function bindCards(root) {
    root.querySelectorAll('.lau-recs__item').forEach(function (li) {
      var s = li.querySelector('[data-lau-color]');
      if (s) s.addEventListener('change', function () {
        var opt = s.options[s.selectedIndex];
        li.dataset.variant = s.value;
        var im = li.querySelector('.lau-recs__media img');
        if (im && opt.dataset.img) im.src = opt.dataset.img;
        var pr = li.querySelector('[data-lau-price]');
        if (pr) pr.textContent = money(opt.dataset.price);
        li.querySelectorAll('a').forEach(function (a) { a.href = a.href.replace(/variant=\d+/, 'variant=' + s.value); });
      });
      var b = li.querySelector('[data-lau-add]');
      if (b) b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); addToCart(li.dataset.variant, b); });
    });
  }

  function chipsHTML(us) {
    return '<div class="lau-recs__sizes" role="group" aria-label="Tu talla"><span>Tu talla:</span>' +
      US_SIZES.map(function (s) {
        return '<button type="button" class="lau-recs__chip' + (s === us ? ' is-active' : '') + '" data-lau-size="' + s + '" aria-pressed="' + (s === us) + '">' + s + '</button>';
      }).join('') + '</div>';
  }

  /* ---------- página de producto / carrito ---------- */
  function initPage(root) {
    var mode = root.dataset.mode;
    var limit = parseInt(root.dataset.limit, 10) || 8;
    var heading = root.dataset.heading || '';
    var productId = Number(root.dataset.productId || 0);
    var sizeIdx = parseInt(root.dataset.sizeIdx || '-1', 10);
    var colorIdx = parseInt(root.dataset.colorIdx || '-1', 10);
    var variants = [];
    try { variants = JSON.parse((root.querySelector('[data-lau-variants]') || {}).textContent || '[]'); } catch (e) {}
    var state = { size: null, types: root.dataset.type ? [root.dataset.type] : [], exclude: productId ? [productId] : [], soldOut: false, colorsWithSize: [] };

    function variantById(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i][0]) === String(id)) return variants[i]; return null; }

    function evaluateVariant(id, userChose) {
      var v = variantById(id);
      if (!v || sizeIdx < 0) return;
      var us = toUS(v[1][sizeIdx]);
      if (userChose && us) store(SIZE_KEY, us);
      if (userChose && us) state.size = us;
      state.soldOut = !v[2];
      state.colorsWithSize = [];
      if (state.soldOut && colorIdx > -1) {
        variants.forEach(function (x) { if (x[2] && x[1][sizeIdx] === v[1][sizeIdx]) state.colorsWithSize.push(x[1][colorIdx]); });
      }
      soldOutBanner(v);
    }

    function soldOutBanner(v) {
      var info = root.closest('main') ? document.querySelector('product-info') : null;
      var form = info && info.querySelector('product-form');
      var old = document.getElementById('lau-soldout');
      if (old) old.remove();
      if (!form || !state.soldOut) return;
      var size = sizeIdx > -1 ? v[1][sizeIdx] : '';
      var colors = state.colorsWithSize.slice(0, 5).map(pretty).join(', ');
      var div = document.createElement('div');
      div.id = 'lau-soldout';
      div.className = 'lau-soldout';
      div.innerHTML = '<p><strong>Tu talla ' + esc(size) + ' se agotó en este color.</strong></p>' +
        (colors ? '<p>Este modelo sí está en talla ' + esc(size) + ' en: ' + esc(colors) + '.</p>' : '') +
        '<a href="#' + root.id + '" class="lau-soldout__link">Ver pares disponibles en talla ' + esc(size) + ' →</a>';
      form.insertAdjacentElement('afterend', div);
      div.querySelector('a').addEventListener('click', function (e) {
        e.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    function render(products) {
      var us = state.size || '8';
      var items = pick(products, { size: us, types: state.types, excludeIds: state.exclude, limit: limit });
      var sub = items.length
        ? 'Pares de otras marcas disponibles en tu talla.'
        : 'Ahora mismo no tenemos otros pares en talla ' + esc(us) + '. Prueba otra talla.';
      root.innerHTML = (root.querySelector('[data-lau-variants]') ? root.querySelector('[data-lau-variants]').outerHTML : '') +
        '<div class="lau-recs__head"><h2 class="lau-recs__heading h2">' + esc(heading) + '</h2>' +
        '<p class="lau-recs__sub">' + sub + '</p>' + chipsHTML(us) + '</div>' +
        '<ul class="lau-recs__list" role="list">' + items.map(function (it) { return cardHTML(it, us, false); }).join('') + '</ul>';
      root.hidden = false;
      bindCards(root);
      root.querySelectorAll('[data-lau-size]').forEach(function (b) {
        b.addEventListener('click', function () { state.size = b.dataset.lauSize; store(SIZE_KEY, state.size); render(products); });
      });
    }

    function draw() { getFeed().then(render).catch(function () { root.hidden = true; }); }

    if (mode === 'product') {
      var stored = store(SIZE_KEY);
      if (stored) state.size = stored;
      // Si la URL trae ?variant= la talla de esa variante manda.
      evaluateVariant(root.dataset.variant, root.dataset.fromUrl === '1');
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
          var v = evt && evt.data && evt.data.variant;
          if (!v) return;
          evaluateVariant(v.id, true);
          draw();
        });
      }
      draw();
    } else {
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ref = refFromCart(cart);
          state.size = ref.size || store(SIZE_KEY) || '8';
          state.types = ref.types;
          state.exclude = ref.exclude;
          draw();
        })
        .catch(function () { root.hidden = true; });
    }
  }

  function refFromCart(cart) {
    var ref = { size: null, types: [], exclude: [] };
    (cart.items || []).forEach(function (it) {
      ref.exclude.push(it.product_id);
      if (it.product_type && ref.types.indexOf(it.product_type) === -1) ref.types.push(it.product_type);
      if (!ref.size) {
        (it.options_with_values || []).forEach(function (o) {
          var n = String(o.name || '').toLowerCase();
          if (!ref.size && (n === 'talla' || n === 'size' || n === 'tamaño')) ref.size = toUS(o.value);
        });
      }
    });
    if (ref.size) store(SIZE_KEY, ref.size);
    return ref;
  }

  /* ---------- notificación de carrito (popup al agregar) ---------- */
  var notifBusy = false, notifQueued = false;
  function ensureNotifBox() {
    var n = document.getElementById('cart-notification');
    if (!n) return null;
    var box = document.getElementById('lau-recs-mini');
    if (!box) {
      box = document.createElement('div');
      box.id = 'lau-recs-mini';
      box.className = 'lau-recs lau-recs--mini';
      box.hidden = true;
      var links = n.querySelector('.cart-notification__links');
      if (links) n.insertBefore(box, links); else n.appendChild(box);
    }
    return box;
  }

  function refreshNotification() {
    var box = ensureNotifBox();
    if (!box) return;
    if (notifBusy) { notifQueued = true; return; }
    notifBusy = true;
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ref = refFromCart(cart);
        var us = ref.size || store(SIZE_KEY);
        if (!us) { box.hidden = true; return; }
        return getFeed().then(function (products) {
          var items = pick(products, { size: us, types: ref.types, excludeIds: ref.exclude, limit: 6 });
          if (!items.length) { box.hidden = true; return; }
          box.innerHTML = '<p class="lau-recs__mini-heading">A nuestras clientas también les gusta</p>' +
            '<p class="lau-recs__mini-sub">Disponibles en tu talla ' + esc(us) + '</p>' +
            '<ul class="lau-recs__list" role="list">' + items.map(function (it) { return cardHTML(it, us, true); }).join('') + '</ul>';
          box.hidden = false;
          bindCards(box);
        });
      })
      .catch(function () { box.hidden = true; })
      .then(function () {
        notifBusy = false;
        if (notifQueued) { notifQueued = false; refreshNotification(); }
      });
  }

  function watchNotification() {
    var n = document.getElementById('cart-notification');
    if (!n) return;
    ensureNotifBox();
    var wasActive = n.classList.contains('active');
    new MutationObserver(function () {
      var isActive = n.classList.contains('active');
      if (isActive && !wasActive) refreshNotification();
      wasActive = isActive;
    }).observe(n, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('[data-lau-recs]').forEach(initPage);
    watchNotification();
    // Precarga el feed en páginas de producto/colección para que el popup salga rápido.
    if (!onCartPage()) setTimeout(function () { getFeed().catch(function () {}); }, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
